(function () {
    'use strict';

    angular.module("imApp").factory("acVatCodesService", [function () {
        let service = {};

        return service;
    }]);
})();
